import { Kebab } from '@social-solutions/component-library';
import { Trash } from '@styled-icons/foundation/Trash';
import { ClipboardCopy } from '@styled-icons/heroicons-outline/ClipboardCopy';
import styled from 'styled-components';

export const ActionButton = styled.button`
  background-color: white;
  border: 1px solid #20907f;
  color: #20907f;
  font-weight: bold;
  width: 110px;
  max-width: 110px;
  border-radius: 25px;
  padding: 8px;
  margin: 10px;
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    cursor: pointer;
    background-color: #20907f;
    color: white;
  }
  &:disabled {
    background-color: #ccc;
    border: 1px solid #ccc;
    color: white;
    cursor: default;
  }
`;

export const StyledLabel = styled.label`
  display: block;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0.5px;
  line-height: 14px;
  text-transform: uppercase;
  margin: 15px 0px 5px 0px;
  color: #999999;

  &:first-child {
    margin-top: 0;
  }
`;

export const StyledText = styled.label`
  display: block;
  font-size: 11px;
  letter-spacing: 0.5px;
  line-height: 14px;
  margin: 15px 0px 5px 0px;
  color: #20907F;
  word-break: break-word;

  &:first-child {
    margin-top: 0;
  }
`;

export const ClipboardCopyIcon = styled(ClipboardCopy)`
  color: #000;
  &:hover {
    background-color: #FFEBBD;
    outline: none;
  }
`;

export const ClipboardCopyWrapper = styled.div`
  border-radius: 20px;
  width: 18px;
  padding: 10px;
  &:hover {
    cursor: pointer;
    background-color: #FFEBBD;
    outline: none;
  }
`;

export const ToggleContainer = styled.div`
  padding-top: 20px;
  display: flex;
  justify-content: center;
  align-items: start;
`;

export const StyledKebab = styled(Kebab)`
  border-left: 1px solid #cccccc;
  font-size: 20px;
  padding-left: 5px;
  ul {
    border-color: ${({ theme }) => theme.input.border || 'unset'};
    li {
      & div:not(:last-child) {
        border-bottom: 1px solid ${({ theme }) => theme.input.border || 'unset'};
      }
    }
  }
  z-index: 6; // dropdown should show on top of all other elements within CalendarWrapper
`;

export const KebabItem = styled.div`
  background-color: ${({ theme }) => theme.input.background || 'unset'};
  padding: 10px;
  svg g {
    fill: ${({ theme }) => theme.text.primary || 'unset'};
  }

  span {
    color: ${({ theme }) => theme.text.primary || 'unset'};
    font-size: 14px;
  }

  &:hover {
    background-color: ${({ theme }) => theme.input.hover.primary || 'unset'};
  }
  .kebab-item-button-text {
    padding-right: 10px;
    padding-left: 10px;
  }
`;

export const TrashIcon = styled(Trash)`
  padding-left: 10px;
  color: #000;
`;

export const TableWrapper = styled.div`
	height: 100%;
  margin: 20px;
  table {
    border-collapse: collapse;
  }
  th {
    text-align: left;
    &:active, &:focus {
      outline: none;
    }
  }
  p {
    color: ${({ theme }) => theme.text.tertiary || 'unset'};
  }
  .toggle-cell {
    padding-top: 20px;
  };
  .table-with-custom-row > table {
    width: 100%;
    @media only screen and (max-width: 971px) {
      width: 100%;
    }
  };
  .url-wrapper {
    overflow: hidden;
  }
`;

export const FormGroup = styled.div`
  padding: 10px;
`;

export const BadgeIcon = styled.span`
  background-color: #003d50;
  border-radius: 12px;
  color: white;
  display: inline-block;
  max-height: 26px;
  padding: 4px 8px;
  text-transform: uppercase;
`;

export const URL = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow:ellipsis;
  max-width: 50%;
`;
